class ToggleElementsViaRadioButtons {
  // checkboxesWrapper: string of the container holding the checkboxes
  // dict: {
  //    key: value from radio button on change
  //    value: the css selector of an element to toggle
  //           show/hide via its corresponding radio button
  // }
  constructor(checkboxesWrapper, dict = {}) {
    this.checkboxesWrapper = checkboxesWrapper;
    this.checkboxesWrapperElement = $(checkboxesWrapper);
    this.values = Object.keys(dict);
    this.rowsDict = Object.entries(dict).reduce((obj, [key, value]) => {
      obj[key] = $(value);
      return obj;
    }, {});
  }

  getRadioButtons = () => {
    return this.checkboxesWrapperElement.find("input[type=radio]");
  };

  getCheckedValue = () => {
    return this.checkboxesWrapperElement
      .find("input[type=radio]:checked")
      .val();
  };

  onRadioButtonToggle = (event) => {
    const { target } = event;
    const radioButton = $(target);
    const value = radioButton.val();
    if (this.rowsDict[value]) {
      this.showThis(value);
      this.hideAllExceptThis(value);
    } else {
      this.hideAll();
    }
  };

  showThis = (value) => {
    $(this.rowsDict[value]).show();
  };

  hideAllExceptThis = (value) => {
    Object.entries(this.rowsDict).forEach(([radioButtonValue, element]) => {
      if (value !== radioButtonValue) {
        $(element).hide();
      }
    });
  };

  hideAll = () => {
    Object.values(this.rowsDict).forEach((element) => $(element).hide());
  };

  attach = () => {
    const selectedRadioButtonValue = this.getCheckedValue();
    if (selectedRadioButtonValue && this.rowsDict[selectedRadioButtonValue]) {
      this.hideAllExceptThis(selectedRadioButtonValue);
    } else {
      this.hideAll();
    }
    const radioButtons = this.getRadioButtons();
    radioButtons.each((_, radioButton) => {
      $(radioButton).change(this.onRadioButtonToggle);
    });
  };

  detach = () => {
    this.getRadioButtons().each((_, radioButton) => {
      $(radioButton).off("change", this.onRadioButtonToggle);
    });
  };
}

export default ToggleElementsViaRadioButtons;
